// extracted by mini-css-extract-plugin
export default {"badges":"TrademarkBadges_badges__mIzf6"};